import { render } from "./Dashboard.vue?vue&type=template&id=36d400f0"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
script.render = render

export default script